import React, { useRef } from 'react';
import { Header } from './Header';
import { ScenarioCards } from './ScenarioCards';
import { GrowthChart } from './GrowthChart';
import { StrategyDetails } from './StrategyDetails';
import type { ScenarioResult } from '../../types';

interface CalculatorResultsProps {
  results: ScenarioResult | null;
  isLoading: boolean;
}

export function CalculatorResults({ results, isLoading }: CalculatorResultsProps) {
  const chartRef = useRef<any>(null);

  if (!results) return null;

  return (
    <div className="p-6">
      <Header results={results} chartRef={chartRef} />
      <ScenarioCards results={results} />
      <GrowthChart results={results} ref={chartRef} />
      <StrategyDetails />
    </div>
  );
}